import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import DocumentModal from './DocumentModel';
import { Stack } from '@mui/system';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import RejectReasonDialog from './RejectReasonDIalog';
import { GetAecsList } from 'API/AecOnboarding/api';
// import ImageModal from '../Approval/Components/ImageModal';



// function createData(name, code, population, size) {
//   const density = population / size;
//   return { name, code, population, size, density };
// }

// const rows = [
//   createData('India', 'IN', 1324171354, 3287263),
//   createData('China', 'CN', 1403500365, 9596961),
//   createData('Italy', 'IT', 60483973, 301340),
//   createData('United States', 'US', 327167434, 9833520),
//   createData('Canada', 'CA', 37602103, 9984670),
//   createData('Australia', 'AU', 25475400, 7692024),
//   createData('Germany', 'DE', 83019200, 357578),
//   createData('Ireland', 'IE', 4857000, 70273),
//   createData('Mexico', 'MX', 126577691, 1972550),
//   createData('Japan', 'JP', 126317000, 377973),
//   createData('France', 'FR', 67022000, 640679),
//   createData('United Kingdom', 'GB', 67545757, 242495),
//   createData('Russia', 'RU', 146793744, 17098246),
//   createData('Nigeria', 'NG', 200962417, 923768),
//   createData('Brazil', 'BR', 210147125, 8515767),

// ];

// function formatDate(dateString) {
//   const date = new Date(dateString);

//   const day = date.getDate().toString().padStart(2, '0');
//   const month = (date.getMonth() + 1).toString().padStart(2, '0');
//   const year = date.getFullYear();
//   const formattedDate = `${day}-${month}-${year}`;

//   return `${formattedDate}`;
// }

export default function KycTable(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false)
  const [openRejectReason, setOpenRejectReason] = React.useState(false)
  const [RejectData, setRejectData] = useState(null)

  const [rows, setRows] = useState(null)
  const [FilteredData, setFilteredData] = useState(null)

  const handleClickOpen = (row) => {
    console.log("row",row,FilteredData);
    setOpen(true);
    setData(row);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    GetAecsList(props.filter,newPage+1,setRows, setIsLoading)

  };

  const handleRejectReasonOpen = (row) => {
    setOpenRejectReason(true);
    setRejectData(row);

  }

  const handleRejectReasonClose = () => {
    setOpenRejectReason(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchList = (filter) => {
    GetAecsList(filter,page+1,setRows, setIsLoading)
  }

  const handleGetList = () => {
    GetAecsList(props.filter,page+1,setRows, setIsLoading)
  }

  useEffect(() => {
    handleGetList()
    props.setCallback({function:handleSearchList})
  }, [])

  // console.log("filtered",FilteredData);
  console.log("props.", props);


  useEffect(() => {
    if (rows) {
      // console.log("rows",rows);

      let filtered = rows.agent_data;

      // Apply type-based filtering
      if (props.type === "pending") {
        filtered = filtered.filter(row => !row.activation.nseit_status || row.activation.nseit_status === "Pending");
      } else if (props.type === "rejected") {
        filtered = filtered.filter(row => row.activation.nseit_status === "Rejected");
      } else {
        filtered = filtered.filter(row => row.activation.nseit_status === "Approved");
      }

      // Apply additional filtering only if filter values exist


      setFilteredData(filtered);


    }
    else{
      setFilteredData(null)
    }
  }, [rows, props.type])



  return (
    isLoading ?
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      :
      <div style={{ width: '100%' }}>
        <RejectReasonDialog open={openRejectReason} handleClose={handleRejectReasonClose} data={RejectData} />
        <DocumentModal type={props.type} open={open} data={FilteredData?FilteredData[data] : {}} handleClose={handleClose} handleGetList={handleGetList} />
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          {
            FilteredData && FilteredData.length > 0 ?
              <TableContainer sx={{ maxHeight: 440, maxWidth: '100%' }}>
                <Table stickyHeader aria-label="sticky table" size='small'>
                  <TableHead>
                    <TableRow>

                      <TableCell
                        align='center'
                        style={{ minWidth: 100 }}
                      >
                        Name
                      </TableCell>

                      <TableCell
                        align='center'
                        style={{ minWidth: 100 }}
                      >
                        Agent Code
                      </TableCell>

                      <TableCell
                        align='center'
                        style={{ minWidth: 150 }}
                      >
                        Mobile Number
                      </TableCell>

                      {
                        <TableCell
                          align='center'
                          style={{ minWidth: 150 }}
                        >
                          Email
                        </TableCell>

                      }

                      <TableCell
                        align='center'
                        style={{ minWidth: 150 }}
                      >
                        State
                      </TableCell>

                      <TableCell
                        align='center'
                        style={{ minWidth: 150 }}
                      >
                        District
                      </TableCell>

                      <TableCell
                        align='center'
                        style={{ minWidth: 150 }}
                      >
                        Uidai ID
                      </TableCell>

                      <TableCell
                        align='center'
                        style={{ minWidth: 120 }}
                      >
                        NSEIT No
                      </TableCell>

                      <TableCell
                        align='center'
                        style={{ minWidth: 100 }}
                      >
                        Action
                      </TableCell>
                      <TableCell
                        align='center'
                        style={{ minWidth: 100 }}
                      >
                        {props.type === 'rejected' ? "Rejected reason" : ""}
                      </TableCell>

                    </TableRow>
                  </TableHead>


                  <TableBody sx={{ width: '100vw' }}>

                    {FilteredData &&
                      FilteredData
                        .map((row, index) => {
                          return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                              <TableCell align='center'>{row.general_details.first_name + " " + row.general_details.last_name}</TableCell>
                              <TableCell align='center'>{row.agent_code}</TableCell>
                              <TableCell align='center'>{row.general_details.mobile_number}</TableCell>
                              <TableCell align='center'>{row.general_details.email_address}</TableCell>
                              <TableCell align='center'>{row.address.retail_state}</TableCell>
                              <TableCell align='center'>{row.address.retail_district}</TableCell>
                              <TableCell align='center'>{row.general_details.aadhaar_card_no}</TableCell>
                              <TableCell align='center'>{row.aec_details.nseit_no}</TableCell>
                              <TableCell align='center'><Button variant='contained' onClick={() => handleClickOpen(index)}>Update</Button></TableCell>
                              <TableCell align='center'>
                                {props.type === 'rejected' ? <Button variant='text' onClick={() => handleRejectReasonOpen(row)}>view</Button> : null}
                              </TableCell>
                            </TableRow>

                          );
                        })}
                  </TableBody>




                </Table>
              </TableContainer>
              :
              // <TableBody sx={{justifyContent:'center'}}>
              //   <TableRow>
              <Stack justifyContent="center" alignItems="center">
                <Typography mt={1} variant="subtitle1" color="grey">No record found</Typography>
              </Stack>
          }

          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={FilteredData ? FilteredData.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
  );
}
